import queryString from 'querystring';

import reduxCreator from '../libs/mk-womanizer/redux-creator';
import axiosPlugin from "../libs/mk-womanizer/ac-axios-plugin";


let redux = reduxCreator.type('STORIES_TAG').plugin(axiosPlugin, {template: "array"});

let fetchStoriesTagAction = redux.fetchActionGet();


export const fetchStoriesTag = (query = {}) => fetchStoriesTagAction(`/stories?${queryString.stringify(query)}`);
export const resetStoriesTag = () => redux.actions.reset();

export const storiesTag = redux.reducer();